import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Team from "../Team/Team";
import ApplicantsDetails from "../Applications/ApplicantsDetails";
import Myprofile from "../Settings/Profile";
import ChangePassword from "../Settings/ChangePassword";
import TermsOfServices from "../Settings/TermsOfService";
import PrivacyPolicy from "../Settings/PrivacyandPolicy";
import FAQs from "../Settings/Faqs";
import CandidateApplications from "../Applications/CandidateApplications";
import CandidateJob from "../JobsList/CandidateJob";
import ApplyJob from "../JobsList/ApplyJob";
import CallLetterView from "../Applications/CallletterView";
import OfferLetterview from "../Applications/OfferLetterview";
import CBTResult from "../Applications/CBTResult";

const CommonRoutes = () => {
  return (
    <Routes>
      <Route path="*" element={<Navigate to={"/"} />} />
      <Route path="/" element={<CandidateJob />} />
      <Route path="/apply/:id" element={<ApplyJob />} />
      <Route path="/appliedjobs" element={<CandidateApplications />} />
      <Route path="/appliedjobs/details/:id" element={<ApplicantsDetails />} />
      <Route extact path="/teams" element={<Team />} />
      <Route extact path="/settings/profile" element={<Myprofile />} />
      <Route extact path="/settings/changepasword" element={<ChangePassword />} />
      <Route extact path="/settings/termsofservices" element={<TermsOfServices />} />
      <Route extact path="/settings/privacyandpolicy" element={<PrivacyPolicy />} />
      <Route extact path="/settings/faqs" element={<FAQs />} />
      <Route extact path="/medical/CallLetter/:id" element={<CallLetterView />} />
      <Route extact path="/physical/CallLetter/:id" element={<CallLetterView />} />
      <Route extact path="/computer/CallLetter/:id" element={<CallLetterView />} />
      <Route extact path="/computer/result/:id" element={<CBTResult />} />
      <Route extact path="/OfferLetterview/:id" element={<OfferLetterview />} />
    </Routes>
  );
};

export default CommonRoutes;